export default {
  data() {
    return {
      entity: {
        title: '',
        quotes: [],
        painting_image: null,
      },
      source: {
        title: '',
        quotes: [],
        painting_image: null,
      },
      imageSelected: false,
      imageOnLoadHandlerSet: false,
      imageLoaded: false,
    };
  },

  methods: {
    addQuote() {
      if (!this.entity.quotes) {
        this.entity.quotes = [];
      }
      this.entity.quotes.push({
        text: '',
      });
      this.entity = {
        ...this.entity,
      };
      this.entity.quotes = [
        ...this.entity.quotes,
      ];
    },
    onDeleteQuote(index) {
      if (!this.entity.quotes) {
        return;
      }
      this.entity.quotes.splice(index, 1);
      this.entity = {
        ...this.entity,
      };
      this.entity.quotes = [
        ...this.entity.quotes,
      ];
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/PaintingGameMixin.js